import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import LoadingSpinner from '../../../Shared/LoadingSpinner/LoadingSpinner'
import TextField from '@mui/material/TextField'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import { IARRte } from '../../../Shared/iar-rte'
import CustomDropdown from '../../../Shared/Dropdown/dropdown'
import ChooseImage from '../../../Shared/ChooseImage'
import ChooseVideo from '../../../Shared/ChooseVideo'
import OnlineVideos from '../../../Shared/OnlineVideos'
import MediaThumbnail from '../../../Shared/MediaThumbnail/MediaThumbnail'
import ButtonSave from '../../../Shared/ButtonSave/ButtonSave'
import { FaRegCheckCircle } from 'react-icons/fa'
import { useCMSContext } from './../../CMSContext'
import { CustomSwitch } from '../../../Shared/Switch/switch'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { GetHeaderWithToken } from '../../../../../resources/Utils'
import { IARDialog } from '../../../Shared/Dialog/IARDialog'
import Button from '@mui/material/Button'
import { useMenuSectionContext } from './../../MenuSection/MenuSectionContext'
import { videoTypes } from '../../../../Constants/videoTypes'
import MenuSectionActions from '../../MenuSection/MenuSectionActions'
import MediaFilesMessage from '../../../Shared/MediaFilesMessage'
import { cloneDeep } from 'lodash'
import './CustomSection.scss'
import serviceBase from '../../../../Services/serviceBase'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'
import { EmptyTagsTypes } from '../../../../Constants/bodyTextValidationsTypes'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import usePrevious from '../../../../../resources/usePrev'
import { isEmpty, omit } from 'lodash'
import { useGetIsDemoDepartment } from '../../../../../resources/useGetIsDemoDepartment'
import { EncondingSectionType } from 'app/Constants/EncodingSectionType'
import { saveSectionVideoProcess } from 'app/Services/serviceSectionsMediaShared'
import {
  getOnlineVideosPayload,
  getImagesPayload,
  getVideosPayload,
  setCustomSectionEncodingPayload
} from '../CustomSection/CustomSectionFunctions'
import PrepublishButtons from 'app/Components/Shared/PrepublishButtons/PrepublishButtons'
import PreviewContentLabel from 'app/Components/Shared/PreviewContentLabel/PreviewContentLabel'

function CustomSection({ title, id, order, isMarketing }) {
  const { errorSnackBarActions } = useErrorSnackBarContext()
  const [loading, setLoading] = useState(true)
  const cmsContext = useCMSContext()
  const {
    iarMember,
    isReadOnlyMember,
    isDemoDepartments,
    fireDepartment,
    socket,
    appConfiguration,
    newVideoEncoding
  } = cmsContext.state

  Interceptor.interceptor(errorSnackBarActions)

  const INITIAL_STATE = React.useMemo(() => {
    return {
      title: appConfiguration.previewEnabled ? '' : title,
      bodyText: '',
      positionFiles: 0,
      postMessage: '',
      sectionActive: true,
      sendPushNotification: false,
      _id: '',
      fireDepartmentIdentifier: '',
      images: [],
      onlineVideos: [],
      videos: [],
      order: 0
    }
  }, [title, appConfiguration.previewEnabled])

  const [customMessageEntity, setCustomMessageEntity] = useState(INITIAL_STATE)
  const [customMessageEntityDiscard, setCustomMessageEntityDiscard] = useState(INITIAL_STATE)
  const [errorLabel, setErrorLabel] = useState('')
  const [images, setImages] = useState([]) // this images is the one to be send in post
  const [videos, setVideos] = useState([]) // this images is the one to be send in post
  const [onlineVideos, setOnlineVideos] = useState([])
  const [dataPosted, setDataPosted] = useState({ posted: false, message: '' })
  const [deletedFiles, setDeletedFiles] = useState([])
  const [tempUpdatedFiles, setTempUpdatedFiles] = useState([])
  const [dialog, setDialog] = useState({ open: false })
  const [errorBodyText, setErrorBodyText] = useState('')
  const [errorTitle, setErrorTitle] = useState('')
  const [isDiscardedMedia, setIsDiscardedMedia] = useState(false)
  const [customSectionsSavingInner, setCustomSectionsSavingInner] = useState([])

  const { setSectionId, setIsCustomSectionBeingSaved } = cmsContext.actions
  const [disabledButton, setDisabledButton] = useState(true)
  const [isDiscarded, setDiscarded] = useState(false)
  const menuSectionContext = useMenuSectionContext()
  const [deletedSeconds, setDeletedSeconds] = useState([])
  const { isDemo } = useGetIsDemoDepartment(isDemoDepartments, fireDepartment)
  //Properties for preview
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false)
  const [isDiscardDialogOpen, setIsDiscardDialogOpen] = useState(false)
  const [isPreviewDialogOpen, setIsPreviewDialogOpen] = useState(false)
  const [isPreviewNotSaveDialogOpen, setIsPreviewNotSavedDialogOpen] = useState(false)
  //end propertis for preview

  const previewedContentRef = useRef(INITIAL_STATE)
  const publishedContentRef = useRef(INITIAL_STATE)
  const previewDiscardContentRef = useRef(INITIAL_STATE)
  const [posting, setPosting] = useState(false)
  const [showPublishedContent, setShowPublishedContent] = useState(true)

  const [bodyText, setBodyText] = useState('')

  useEffect(() => {
    setBodyText(customMessageEntity.bodyText || '')
  }, [customMessageEntity._id, customMessageEntity.bodyText])

  const { customSectionsSaving, lastCustomSectionId } = menuSectionContext.state
  const {
    setCustomSections,
    setPreviewSection,
    setDisabledSort,
    setCustomSectionSaving,
    setLastCustomSectionId
  } = menuSectionContext.actions

  const isNewVideoEncodingProcessActive = useMemo(() => {
    return (
      newVideoEncoding &&
      videos?.some((x) => !customMessageEntityDiscard.videos.some((v) => v.fileName === x.fileName))
    )
  }, [newVideoEncoding, videos, customMessageEntityDiscard.videos])

  const prevLastCustomSecontId = usePrevious(lastCustomSectionId)

  const getCustomSections = useCallback(async () => {
    const response = await MenuSectionActions.getCustomSections(fireDepartment.identifier)
    setCustomSections(response)
  }, [fireDepartment.identifier, setCustomSections])

  const processInnerCustomSectionSocketMessage = useCallback(
    async (args) => {
      setCustomSectionsSavingInner(removeNewSectionsFromIds(args.ids) || [])
      if (args.action === 'start') {
        setDisabledButton(true)
      }
      if (args.action === 'error') {
        setDisabledButton(false)
      }
      if (args.action === 'saved') {
        const response = args.response
        setDisabledSort(false)
        setPreviewSection(false)
        //if Publish is turn on, keep disabled
        if (Boolean(args.isPreview)) setDisabledButton(showPublishedContent)
        else setDisabledButton(false)

        setDataPosted({ posted: true, message: 'Saved' })
        setPosting(false)

        //this apply only if the user keep in the custom section
        if (args.customSectionId === id) {
          args.ids = args.ids.includes(id) ? args.ids.filter((x) => x !== id) : args.ids
          setCustomSectionsSavingInner(removeNewSectionsFromIds(args.ids) || [])
          setLastCustomSectionId(response._id)
          previewDiscardContentRef.current = cloneDeep(args.response)
          if (args.isPreview) {
            previewedContentRef.current = args.response
          } else {
            publishedContentRef.current = args.response
          }

          //XOR validation
          //applies when show showPublishedContent is false and args.isPreview are true
          //applies when show showPublishedContent is true and args.isPreview are false
          if (!showPublishedContent === Boolean(args.isPreview)) {
            setCustomMessageEntityDiscard(cloneDeep({ ...response, sendPushNotification: false }))
            setCustomMessageEntity({ ...response, sendPushNotification: false })
            setImages(response.images ?? [])
            setVideos(response.videos ?? [])
            setOnlineVideos(response.onlineVideos ?? [])
          }
        }

        //this apply if is a new custom section
        if (id.startsWith('customSection')) {
          const sectionsBeingSaved = customSectionsSaving.filter((cs) => cs !== 'customSection')
          setCustomSectionSaving(sectionsBeingSaved || [])
          setSectionId(response._id)
          getCustomSections()
        }
      }
    },
    [
      customSectionsSaving,
      getCustomSections,
      id,
      setCustomSectionSaving,
      setDisabledSort,
      setLastCustomSectionId,
      setPreviewSection,
      setSectionId,
      showPublishedContent
    ]
  )

  useEffect(() => {
    if (!isMarketing && appConfiguration.previewEnabled && showPublishedContent)
      setDisabledButton(true)
  }, [isMarketing])

  useEffect(() => () => setLastCustomSectionId(''), [])

  useEffect(() => {
    if (prevLastCustomSecontId !== lastCustomSectionId) {
      setLoading(false)
      setCustomMessageEntity(INITIAL_STATE)
      setImages([])
      setVideos([])
      setDataPosted({ posted: false, message: '' })
      setDeletedFiles([])
      setOnlineVideos([])
    }
  }, [prevLastCustomSecontId, lastCustomSectionId, INITIAL_STATE])

  const isReadyToSave = () => {
    let isReady = true
    const richText = bodyText || customMessageEntity.bodyText

    if (!richText || EmptyTagsTypes.EmptyTag.includes(richText)) {
      setErrorBodyText('This field is required!')
      setDisabledButton(false)
      setPosting(false)
      setTimeout(() => {
        setErrorBodyText('')
      }, 5000)
      isReady = false
    }

    customMessageEntity.title = customMessageEntity?.title ? customMessageEntity.title.trim() : ''
    if (customMessageEntity.title === '' || customMessageEntity.title === '<p><br></p>') {
      setErrorTitle('This field is required!')
      setPosting(false)
      setDisabledButton(false)
      setTimeout(() => {
        setErrorTitle('')
      }, 5000)
      isReady = false
    }
    return isReady
  }

  const getCustomSectionContent = async () => {
    let previewed = INITIAL_STATE
    
    const publishedResponse = await serviceBase.get(
      `${window._env_.COMMUNITY_API_URL}/custom-sections/custom-sections-by-id/${id}`,
      GetHeaderWithToken()
    ).catch(() => null)

    const previewedResponse = await serviceBase.get(
      `${window._env_.COMMUNITY_API_URL}/custom-sections-preview/${id}`,
      GetHeaderWithToken()
    )

    if(appConfiguration.previewEnabled){
      if (publishedResponse?.status === 205 && previewedResponse?.status === 205) {
        getCustomSections()
        errorSnackBarActions.setOpen(
          true,
          'This custom section already was deleted',
          'warning',
          7000
        )
        return
      }
    }

    const published = publishedResponse?.data._id ? publishedResponse?.data : INITIAL_STATE

    if (appConfiguration.previewEnabled) {

      previewed = previewedResponse?.data || INITIAL_STATE
    } else {
      if (publishedResponse?.status === 205) {
        getCustomSections()
        setDisabledButton(true)
        errorSnackBarActions.setOpen(
          true,
          'This custom section already was deleted',
          'warning',
          7000
        )
      return
      }
    } 
    
    let currentEntity = published

    if (currentEntity) {
      setCustomMessageEntity(currentEntity)
      setCustomMessageEntityDiscard(cloneDeep(currentEntity))
      setImages(currentEntity.images)
      setVideos(currentEntity.videos)
      setOnlineVideos(currentEntity.onlineVideos)
      setLoading(false)
    }

    return { previewed, published }
  }

  const getMarketingCustomSectionContent = useCallback(async () => {
    try {
      const response = await serviceBase.get(
        `${window._env_.COMMUNITY_API_URL}/marketing-custom-section/marketing-custom-sections-by-id/${id}`,
        GetHeaderWithToken()
      )
      if (response.status === 200) {
        setCustomMessageEntity({ ...response.data, sendPushNotification: false })
        setCustomMessageEntityDiscard({ ...response.data, sendPushNotification: false })
        setImages(response.data.images)
        setVideos(response.data.videos)
        if (response.data.onlineVideos.length > 0) {
          setOnlineVideos(response.data.onlineVideos)
        } else {
          setOnlineVideos([])
        }
      }
      setLoading(false)
      setCustomSectionsSavingInner([])
      if (customSectionsSaving && customSectionsSaving.length === 0) setDisabledButton(false)
    } catch (error) {}
  }, [id, customSectionsSaving])

  useEffect(() => {
    ;(async function () {
      if (id && customMessageEntity._id !== id && id !== 'customSection') {
        if (isMarketing) {
          getMarketingCustomSectionContent()
        } else {
          const { previewed, published } = await getCustomSectionContent()
          previewedContentRef.current = previewed
          publishedContentRef.current = published
          previewDiscardContentRef.current = cloneDeep(previewed)
          if (!appConfiguration.previewEnabled) setShowPublishedContent(true)
        }
      } else if (id === 'customSection') {
        setLoading(false)
        setCustomMessageEntity(INITIAL_STATE)
        setCustomMessageEntityDiscard(INITIAL_STATE)
        publishedContentRef.current = INITIAL_STATE
        previewedContentRef.current = INITIAL_STATE
        setImages([])
        setVideos([])
        setOnlineVideos([])
      }
    })()
    return () => {
      setShowPublishedContent(true)
    }
  }, [id])

  useEffect(() => {
    if (!showPublishedContent && appConfiguration.previewEnabled) {
      setCustomMessageEntity(previewedContentRef.current)
      setCustomMessageEntityDiscard(cloneDeep(previewDiscardContentRef.current))
      setImages(previewedContentRef.current.images ?? [])
      setVideos(previewedContentRef.current.videos ?? [])
      setOnlineVideos(previewedContentRef.current.onlineVideos ?? [])
      setBodyText(previewedContentRef.current.bodyText)
    } else {
      setCustomMessageEntity(publishedContentRef.current)
      setCustomMessageEntityDiscard(cloneDeep(publishedContentRef.current))
      setImages(publishedContentRef.current.images ?? [])
      setVideos(publishedContentRef.current.videos ?? [])
      setOnlineVideos(publishedContentRef.current.onlineVideos ?? [])
      setBodyText(publishedContentRef.current.bodyText)
    }
  }, [appConfiguration.previewEnabled, showPublishedContent])

  const setResponseCallback = useCallback(
    (response) => {
      ;(async function () {
        if (response && response._id) {
          //is the menu is marketing get info from marketing custom section
          let url = isMarketing
            ? `${window._env_.COMMUNITY_API_URL}/marketing-custom-section/marketing-custom-sections-by-id/${response._id}`
            : `${window._env_.COMMUNITY_API_URL}/custom-sections/custom-sections-by-id/${response._id}`
          return serviceBase.get(url, GetHeaderWithToken()).then((res) => {
            if (res.status === 200) {
              setCustomMessageEntity({ ...res.data })
              setCustomMessageEntityDiscard(cloneDeep(res.data))
              setImages(res.data.images)
              setVideos(res.data.videos)
              setOnlineVideos(res.data.onlineVideos ?? [])
            }
            setLoading(false)
          })
        }
      })()
    },
    [isMarketing]
  )

  useEffect(() => {
    if (fireDepartment && socket) {
      socket.on(
        `${fireDepartment.fireDepartmentId.toString()}_${id}_custom_section`,
        async (args) => {
          console.log(
            `${fireDepartment.fireDepartmentId.toString()}_${id}_custom_section`,
            args,
            new Date()
          )
          processInnerCustomSectionSocketMessage(args)
        }
      )

      socket.on(
        `${fireDepartment.fireDepartmentId.toString()}_inner_custom_section`,
        async (args) => {
          console.log(
            `${fireDepartment.fireDepartmentId.toString()}_inner_custom_section`,
            args,
            new Date()
          )
          processInnerCustomSectionSocketMessage(args)
        }
      )

      socket.on(
        `${fireDepartment.fireDepartmentId.toString()}_${id}_getof_custom_section`,
        (args) => {
          console.log(
            `${fireDepartment.fireDepartmentId.toString()}_${id}_getof_custom_section`,
            args,
            new Date()
          )
          setCustomSectionsSavingInner(removeNewSectionsFromIds(args?.ids ?? []) || [])
          if (args.action === 'get') {
            // setDisabledButton(true)
          }
        }
      )

      if (!id) {
        socket.on(
          `${fireDepartment.fireDepartmentId.toString()}_${order}_custom_section`,
          async (args) => {
            console.log(
              `${fireDepartment.fireDepartmentId.toString()}_${order}_custom_section`,
              args,
              new Date()
            )
            setCustomSectionsSavingInner(removeNewSectionsFromIds(args?.ids ?? []) || [])
            if (args.action === 'saved' && !args.updated && newVideoEncoding) {
              setDisabledButton(false)
              await setResponseCallback(args.response)
            }
          }
        )
      }
    }
    return () => {
      socket.off(`${fireDepartment.fireDepartmentId.toString()}_${id}_custom_section`)
      socket.off(`${fireDepartment.fireDepartmentId.toString()}_inner_custom_section`)
      socket.off(`${fireDepartment.fireDepartmentId.toString()}_${id}_getof_custom_section`)
      socket.off(`${fireDepartment.fireDepartmentId.toString()}_${order}_custom_section`)
    }
  }, [
    fireDepartment.fireDepartmentId,
    id,
    newVideoEncoding,
    order,
    socket,
    setResponseCallback,
    fireDepartment,
    processInnerCustomSectionSocketMessage
  ])

  useEffect(() => {
    if (errorLabel !== '') {
      errorSnackBarActions.setOpen(true, errorLabel)
    }
  }, [errorLabel])

  const rteChangeHandler = (content) => {
    setBodyText(content.trim())
  }

  const handleChange = useCallback((evt) => {
    const value = evt.target.value
    setCustomMessageEntity((oldState) => ({
      ...oldState,
      [evt.target.name]: value
    }))
  }, [])

  const removeNewSectionsFromIds = (ids) => {
    return ids.filter((x) => x !== 'customSection')
  }

  const sendCustomSection = () => {
    setDataPosted({ ...dataPosted, posted: false })
    const readyToSave = isReadyToSave()
    if (!readyToSave) {
      setErrorLabel('Missing Information')
      errorSnackBarActions.setOpen(true, errorLabel)
      return
    }
    let videoPayload = []
    if (customMessageEntity.videos) {
      videos
        .filter((video) => !customMessageEntity.videos.some((v) => video.fileName === v.fileName))
        .forEach((v) => {
          videoPayload.push({
            originalName: v.FileName,
            type: 'video',
            fileSize: v.fileSize,
            caption: v.caption,
            secondsDuration: v.secondsDuration
          })
        })
    } else {
      videoPayload = videos
    }

    let onlineVideoPayload = []
    if (customMessageEntity.onlineVideos && customMessageEntity.onlineVideos.length > 0) {
      onlineVideos.forEach((v) => {
        onlineVideoPayload.push({
          originalName: v.originalName,
          type: 'online',
          provider: v.provider,
          caption: v.caption,
          fileSize: '',
          url: v.url
        })
      })
    } else {
      onlineVideoPayload = onlineVideos
    }

    const imagesPayload = customMessageEntity.images
      ? images.filter(
          (image) => !customMessageEntity.images.some((im) => image.fileName === im.fileName)
        )
      : images
    const headers = GetHeaderWithToken()
    let url = `${window._env_.COMMUNITY_API_URL}/custom-sections`

    const img = []

    imagesPayload.forEach((image) => {
      img.push({
        originalName: image.originalName,
        caption: image.caption,
        type: image.type,
        fileSize: image.fileSize,
        binary: image.file
      })
    })

    const vid = []
    videoPayload.forEach((video) => {
      vid.push({
        originalName: video.originalName,
        caption: video.caption,
        type: video.type,
        fileSize: video.fileSize,
        binary: video.binary,
        secondsDuration: video.secondsDuration
      })
    })

    const online = []
    onlineVideoPayload.forEach((elem) => {
      online.push({
        originalName: elem.originalName,
        caption: elem.caption,
        type: elem.type,
        url: elem.url,
        provider: elem.provider,
        fileSize: elem.fileSize,
        binary: elem.binary
      })
    })

    const data = {
      _id: customMessageEntity._id || '',
      fireDepartmentIdentifier: fireDepartment.identifier,
      title: customMessageEntity.title,
      bodyText: bodyText,
      images: img,
      videos: vid,
      onlineVideos: online,
      positionFiles: parseInt(customMessageEntity.positionFiles),
      filesToDelete: deletedFiles,
      filesToUpdate: tempUpdatedFiles,
      sectionActive: customMessageEntity.sectionActive,
      order: order,
      sendPushNotification: customMessageEntity.sendPushNotification,
      deletedSeconds: deletedSeconds
    }

    if (!customMessageEntity._id) {
      delete data._id
    }

    const formData = new FormData()

    formData.append('request', JSON.stringify(data))

    videos.forEach((video) => {
      if (video.binary === undefined) return

      formData.append('videos', video.binary, video.originalName)

      video.binary = null
    })

    images.forEach((image) => {
      if (image.file === undefined) return

      formData.append('images', image.file, image.originalName)
      image.file = null
    })
    setPreviewSection(false)
    setDisabledButton(true)

    if (id || customMessageEntity._id) {
      serviceBase.get(`${url}/emit-start/${fireDepartment.fireDepartmentId}?id=${id}`, headers)
    } else {
      serviceBase.get(`${url}/emit-start/${fireDepartment.fireDepartmentId}`, headers)
      setCustomSectionSaving([...customSectionsSaving, data.title])
    }
    setIsCustomSectionBeingSaved(true)
    serviceBase
      .post(url, formData, {
        fullusername: iarMember.fullName
      })
      .then(
        (response) => {
          setLastCustomSectionId(response.data._id)
          setCustomMessageEntity({ ...response.data, sendPushNotification: false })
          setCustomMessageEntityDiscard({ ...response.data, sendPushNotification: false })

          if (response.data && response.data.images && response.data.images.length > 0) {
            setImages(response.data.images)
          }
          if (response.data && response.data.videos && response.data.videos.length > 0) {
            setVideos(response.data.videos)
          }
          if (
            response.data &&
            response.data.onlineVideos &&
            response.data.onlineVideos.length > 0
          ) {
            setOnlineVideos(response.data.onlineVideos)
          }

          setDataPosted({ posted: true, message: 'Saved' })
          setDeletedSeconds([])
          setDeletedFiles([])
          getCustomSections()
          setDisabledButton(false)
          setIsCustomSectionBeingSaved(false)
        },
        (err) => {
          errorSnackBarActions.setOpen(true)
          setDataPosted({ posted: false, message: 'Error while saving changes' })
          console.log(err)
          setDisabledButton(false)
          setIsCustomSectionBeingSaved(false)
        }
      )
  }

  const sendCustomSectionPreview = async () => {
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)
    var readyToSave = isReadyToSave()

    if (!readyToSave) {
      closePreviewDialog()
      setErrorLabel('Missing Information')
      errorSnackBarActions.setOpen(true, errorLabel)
      return
    }

    const online =
      onlineVideos?.map((v) => ({
        originalName: v.originalName,
        type: 'online',
        caption: v.caption,
        provider: v.provider,
        fileSize: '',
        url: v.url,
        binary: v.binary
      })) ?? []

    const img =
      images
        ?.filter(
          (x) =>
            !customMessageEntityDiscard.images.some((i) => {
              return x.fileName === i.fileName
            })
        )
        .map((v) => ({
          originalName: v.originalName,
          caption: v.caption,
          type: v.type,
          fileSize: v.fileSize,
          binary: v.file
        })) ?? []

    const data = {
      _id: id,
      fireDepartmentIdentifier: fireDepartment.identifier,
      title: customMessageEntity.title,
      bodyText: bodyText,
      images: img,
      videos: [],
      onlineVideos: online,
      positionFiles: parseInt(customMessageEntity.positionFiles),
      filesToDelete: deletedFiles,
      filesToUpdate: tempUpdatedFiles,
      sectionActive: customMessageEntity.sectionActive,
      order: order,
      sendPushNotification: customMessageEntity.sendPushNotification,
      deletedSeconds: deletedSeconds
    }

    const formData = new FormData()

    formData.append('request', JSON.stringify(data))

    images.forEach((image) => {
      if (!image.file) return

      formData.append('images', image.file, image.originalName)

      image.file = null
    })

    setPreviewSection(false)
    setDisabledButton(true)

    let socketEmitUrl = `${window._env_.COMMUNITY_API_URL}/custom-sections`
    const headers = GetHeaderWithToken()
    if (id || customMessageEntity._id) {
      serviceBase.get(
        `${socketEmitUrl}/emit-start/${fireDepartment.fireDepartmentId}?id=${id}`,
        headers
      )
    } else {
      serviceBase.get(`${socketEmitUrl}/emit-start/${fireDepartment.fireDepartmentId}`, headers)
      setCustomSectionSaving([...customSectionsSaving, data.title])
    }

    setIsCustomSectionBeingSaved(true)
    closePreviewDialog()
    serviceBase
      .post(`${window._env_.COMMUNITY_API_URL}/custom-sections-preview`, formData, {
        fullusername: iarMember.fullName
      })
      .then(
        (response) => {
          setLastCustomSectionId(response.data._id)

          setDataPosted({ posted: true, message: 'Saved' })
          setDeletedSeconds([])
          setDeletedFiles([])
          getCustomSections()
          setDisabledButton(false)
          setIsCustomSectionBeingSaved(false)
          closePreviewDialog()
          setPosting(false)
        },
        (err) => {
          errorSnackBarActions.setOpen(true)
          setDataPosted({ posted: false, message: 'Error while saving changes' })
          console.log(err)
          setDisabledButton(false)
          setIsCustomSectionBeingSaved(false)
          closePreviewDialog()
        }
      )
  }

  const removeOnlineVideo = (file) => {
    const files = deletedFiles

    files.push(file)
    const tempOnlineVideos = onlineVideos.filter((i) => i.originalName !== file.originalName)
    setOnlineVideos(tempOnlineVideos)
  }

  const removeAsset = (file, type) => {
    const files = deletedFiles
    const secondsDeleted = deletedSeconds

    switch (type) {
      case 'image':
        if (!file.isNew) {
          files.push(file.fileName)
          setDeletedFiles(files)
        }
        const tempImages = images.filter((i) => i.fileName !== file.fileName)
        setImages(tempImages)
        break
      case 'video':
        if (!file.isNew) {
          files.push(file.fileName)
          secondsDeleted.push(file.secondsDuration ? file.secondsDuration : 0)
          setDeletedFiles(files)
          setDeletedSeconds(secondsDeleted)
        }
        const tempVideos = videos.filter((i) => i.fileName !== file.fileName)
        setVideos(tempVideos)
        break
      default:
        break
    }
  }

  const updateAsset = (file) => {
    if (
      tempUpdatedFiles.length > 0 &&
      tempUpdatedFiles.some((el) => el.fileName === file.fileName)
    ) {
      let newTemp = tempUpdatedFiles
      newTemp.filter((el) => el.fileName === file.fileName)[0].caption = file.caption
      setTempUpdatedFiles(newTemp)
    } else {
      setTempUpdatedFiles((prev) => [...prev, { caption: file.caption, fileName: file.fileName }])
    }
  }

  const renderSavedMessage = () => {
    if (dataPosted.posted) {
      return (
        <div className="save-message">
          <FaRegCheckCircle className="check-circle" />
          <span className="save-message-text">{dataPosted.message}</span>
        </div>
      )
    }
  }

  const handleCheckboxChange = useCallback((evt) => {
    const value = evt.target.checked
    setCustomMessageEntity((prevState) => ({ ...prevState, sendPushNotification: value }))
  }, [])

  const openConfirmationDialog = () => {
    setDialog({ open: true })
    setDiscarded(false)
  }

  const cancelDialog = () => {
    setDialog({ open: false })
    setDiscarded(false)
  }

  const discardChanges = () => {
    setIsDiscardedMedia((prev) => !prev)
    setDialog({ open: false })
    setCustomMessageEntity(cloneDeep(customMessageEntityDiscard))
    setBodyText(cloneDeep(customMessageEntityDiscard.bodyText))
    setImages(cloneDeep(customMessageEntityDiscard.images))
    setVideos(cloneDeep(customMessageEntityDiscard.videos))
    setOnlineVideos(customMessageEntityDiscard.onlineVideos)
    setDeletedFiles([])
    setTempUpdatedFiles([])
    setDiscarded((prev) => !prev)
  }

  const sectionActiveChange = useCallback(() => {
    setCustomMessageEntity((oldState) => ({
      ...oldState,
      sectionActive: !oldState.sectionActive
    }))
  }, [])

  const emitSocketMessage = async () => {
    const headers = GetHeaderWithToken()
    const url = `${window._env_.COMMUNITY_API_URL}/custom-sections`
    if (id || customMessageEntity._id) {
      await serviceBase.get(
        `${url}/emit-start/${fireDepartment.fireDepartmentId}?id=${id}`,
        headers
      )
    } else {
      await serviceBase.get(`${url}/emit-start/${fireDepartment.fireDepartmentId}`, headers)
      setCustomSectionSaving([...customSectionsSaving, id])
    }
  }

  const processSectionVideoProcessSave = async (isPreview) => {
    setDataPosted({ ...dataPosted, posted: false })
    setDisabledButton(true)
    setPosting(true)
    closePreviewDialog()

    const readyToSave = isReadyToSave()

    if (!readyToSave) {
      setErrorLabel('Missing Information')
      errorSnackBarActions.setOpen(true, errorLabel)
      return
    }

    setPreviewSection(false)
    const onlineVideosPayload = getOnlineVideosPayload(onlineVideos)
    const imagesPayload = getImagesPayload(customMessageEntityDiscard, images)
    const videosPayload = getVideosPayload(customMessageEntityDiscard, videos)

    const customSectionPayload = setCustomSectionEncodingPayload(
      imagesPayload,
      videosPayload.length,
      onlineVideosPayload,
      isPreview ? EncondingSectionType.CustomSectionPreview : EncondingSectionType.CustomSection,
      customMessageEntity,
      deletedFiles,
      fireDepartment,
      images,
      iarMember,
      tempUpdatedFiles,
      bodyText,
      order
    )

    emitSocketMessage()

    if (id.startsWith('customSection')) {
      setDisabledSort(true)
      setCustomSectionSaving([...customSectionsSaving, id])
    }

    setIsCustomSectionBeingSaved(true)

    const customSectionResponse = await saveSectionVideoProcess(
      customSectionPayload,
      videosPayload,
      images
    )

    if (!customSectionResponse?.sectionVideoProcessResponse?._id) {
      errorSnackBarActions.setOpen(true)
    }

    setIsCustomSectionBeingSaved(false)
  }

  useEffect(() => {
    setDisabledButton(posting || (appConfiguration?.previewEnabled && showPublishedContent))
  }, [appConfiguration.previewEnabled, posting, showPublishedContent])

  const switchContent = () => {
    setErrorBodyText('')
    setErrorTitle('')
    if (previewedContentRef.current._id !== customMessageEntity._id) {
      setCustomMessageEntity(INITIAL_STATE)
    }

    if (!showPublishedContent) {
      setBodyText(customMessageEntity.bodyText)
      previewedContentRef.current = {
        ...customMessageEntity,
        videos,
        images,
        onlineVideos,
        bodyText
      }
    }

    setShowPublishedContent((prev) => !prev)
    setDiscarded((prevState) => !prevState)
  }

  const publishPost = async () => {
    try {
      setIsSaveDialogOpen(false)
      setDataPosted({ ...dataPosted, posted: false })
      setPosting(true)
      const customSectionId = previewedContentRef.current._id
      const sendPushNotification = customMessageEntity.sendPushNotification
      const url = `${
        window._env_.COMMUNITY_API_URL
      }/custom-sections-preview/publish/${customSectionId}/${Boolean(sendPushNotification)}`
      const response = await serviceBase.post(url, undefined, { fullusername: iarMember.fullName })
      publishedContentRef.current = response.data
      previewDiscardContentRef.current = cloneDeep(response.data)
      previewedContentRef.current = response.data
      setCustomMessageEntity(response.data)
      setCustomMessageEntityDiscard(cloneDeep(response.data))
      setImages(response.data?.images ?? [])
      setVideos(response.data?.videos ?? [])
      setOnlineVideos(response.data?.onlineVideos ?? [])

      setDataPosted({ posted: true, message: 'Saved' })
      setDeletedSeconds([])
      setDeletedFiles([])
      console.log(`POST custom section Response: ${response.data}`)
      callbackSuccessForPreview()
    } catch (error) {
      setErrorLabel('There was an error Publishing recruitment section')
      errorSnackBarActions.setOpen(true, errorLabel)
    }
  }

  const callbackSuccessForPreview = () => {
    setPosting(false)
  }

  const openPreviewDialog = () => {
    setIsPreviewDialogOpen(true)
  }

  const closePreviewDialog = () => {
    setIsPreviewDialogOpen(false)
  }

  const openNotSavedPreviewDialog = () => {
    setIsPreviewNotSavedDialogOpen(true)
  }

  const closeNotSavedPreviewDialog = () => {
    setIsPreviewNotSavedDialogOpen(false)
  }
  const openSaveDialog = () => {
    setIsSaveDialogOpen(true)
  }

  const closeSaveDialog = () => {
    setIsSaveDialogOpen(false)
    customMessageEntity.sendPushNotification = false
  }

  const closeDiscardDialog = () => {
    setIsDiscardDialogOpen(false)
  }

  const openDiscardDialog = () => {
    setIsDiscardDialogOpen(true)
  }

  const publishButtonValidations = () => {
    const customMessageEntityToCompare = omit(customMessageEntity, ['sendPushNotification'])
    const customMessageEntityDiscardToCompare = omit(customMessageEntityDiscard, [
      'sendPushNotification'
    ])
    if (
      JSON.stringify(customMessageEntityToCompare) !==
        JSON.stringify(customMessageEntityDiscardToCompare) ||
      bodyText !== customMessageEntityDiscard.bodyText ||
      JSON.stringify(videos) !== JSON.stringify(customMessageEntity.videos) ||
      JSON.stringify(images) !== JSON.stringify(customMessageEntity.images) ||
      JSON.stringify(onlineVideos) !== JSON.stringify(customMessageEntity.onlineVideos)
    ) {
      openNotSavedPreviewDialog()
    } else {
      openSaveDialog()
    }
  }

  const saveDialogCustomContent = useMemo(
    () => (
      <Grid container>
        <Grid size={12}>
          You are about to publish the new section content do you want to continue?
        </Grid>
        <Grid size={12}>
          <FormControlLabel
            control={
              <Checkbox
                name="sendPushNotification"
                color="primary"
                className="checkbox-notification"
                checked={customMessageEntity.sendPushNotification}
                value={customMessageEntity.sendPushNotification}
                onChange={handleCheckboxChange}
                disabled={appConfiguration.previewEnabled && showPublishedContent}
              />
            }
            label="Send notification to users when saved"
          />
        </Grid>
      </Grid>
    ),
    [
      customMessageEntity.sendPushNotification,
      appConfiguration.previewEnabled,
      showPublishedContent
    ]
  )

  const saveWithoutPreview = () => {
    if (isNewVideoEncodingProcessActive) processSectionVideoProcessSave(false)
    else sendCustomSection()
  }

  const savePreview = () => {
    if (isNewVideoEncodingProcessActive) processSectionVideoProcessSave(true)
    else sendCustomSectionPreview()
  }

  const disableForm = useMemo(() => {
    return (
      (appConfiguration?.previewEnabled && showPublishedContent) || isMarketing || isReadOnlyMember
    )
  }, [appConfiguration?.previewEnabled, isMarketing, isReadOnlyMember, showPublishedContent])

  return (
    <div className="App custom-section">
      <IARDialog
        open={isPreviewNotSaveDialogOpen}
        title="Save Preview first"
        content="Please save your changes in preview before publishing"
        onOk={closeNotSavedPreviewDialog}
        onCancel={closeNotSavedPreviewDialog}
        previewNotSaved={true}
      />
      <div className="page-header">Menu Section - {customMessageEntity.title}</div>
      {loading && <LoadingSpinner />}
      {!loading && (
        <>
          <IARDialog
            open={dialog.open}
            title="Confirm"
            content="Do you want to discard your changes?"
            onOk={discardChanges}
            onCancel={cancelDialog}
          />
          <Container maxWidth="lg">
            <Grid container spacing={2}>
              <Grid size={12}>
                {isMarketing ? (
                  <div className="page-description">
                    This is a marketing page created by IaR administrator, this page will be visible
                    by your Community Members in MyLS APP, if your need to request a change or do a
                    comment on this page please send an e-mail to{' '}
                    <a id="aMail" href="mailto:MyLSNameChange@emergencysmc.com">
                      MyLSNameChange@emergencysmc.com
                    </a>{' '}
                    . This Page only can be edited by IaR Administrator in "+Marketing Section" Menu
                    option
                  </div>
                ) : (
                  <div className="page-description">
                    This is an optional page, and you can create up to 10 of these customized pages
                    within your app. Suggested uses include things such as listings of emergency
                    telephone numbers applicable to your community; emergency planning lists and
                    resources; fire safety checklists; membership information and rosters; emergency
                    shelter information and locations; listings of important event dates; FAQ's;
                    first aid information and resources; links to reservation pages for banquet
                    rooms; information about upcoming budget votes; and anything else that can
                    benefit your community members.
                  </div>
                )}
              </Grid>
              {!isMarketing && !isDemo && (
                <>
                  <Grid size={12} className="container-field">
                    {appConfiguration.previewEnabled && (
                      <div className="session-active">
                        <span>Display Content as PREVIEW MODE</span>
                        <CustomSwitch
                          name="showPublished"
                          value={!showPublishedContent}
                          sectionActiveChange={switchContent}
                          useYesNoButtons={true}
                        />
                        {!isMarketing && (
                          <PreviewContentLabel
                            showPublished={showPublishedContent}
                            previewEnabled={appConfiguration.previewEnabled}
                          />
                        )}
                      </div>
                    )}
                  </Grid>
                  <Grid size={5} className="container-field">
                    <div className="session-active">
                      <span>Section Visible on MyLS App</span>
                      <CustomSwitch
                        name="sectionActive"
                        value={customMessageEntity.sectionActive}
                        sectionActiveChange={sectionActiveChange}
                        disabled={disableForm}
                        useYesNoButtons={true}
                      />
                    </div>
                  </Grid>
                </>
              )}
              <Grid size={12}>
                <form className="page-content" noValidate autoComplete="off">
                  <Grid size={12}>
                    <label htmlFor="title">Title</label> <br />
                    <label htmlFor="error" className="error-text">
                      {errorTitle}
                    </label>
                    <TextField
                      autoFocus={true}
                      className="title"
                      id="title"
                      name="title"
                      variant="outlined"
                      value={customMessageEntity.title}
                      onChange={handleChange}
                      disabled={disableForm}
                    />
                  </Grid>
                  <Grid size={12} className="body-text">
                    <label htmlFor="message">Body text</label> <br />
                    <label htmlFor="error" className="error-text">
                      {errorBodyText}
                    </label>
                    {
                      <IARRte
                        onChange={rteChangeHandler}
                        content={customMessageEntity.bodyText}
                        discarded={isDiscarded}
                        reset={prevLastCustomSecontId !== lastCustomSectionId}
                        disableHandleChange={disableForm}
                      />
                    }
                  </Grid>
                  <Grid size={12}>
                    <div className="dropdown-container">
                      <div>
                        <label htmlFor="positionFiles">Position images and videos</label> <br />
                        <CustomDropdown
                          name="positionFiles"
                          value={customMessageEntity?.positionFiles || 0}
                          onChange={handleChange}
                          disableHandleChange={disableForm}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid container>
                    <Grid size={12}>
                      <Grid className="container-field">
                        <label htmlFor="images" className="body-text">
                          Media Files
                        </label>
                        <MediaFilesMessage max={5}></MediaFilesMessage>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid size={{ xs: 12, md: 6 }} className="media-files">
                      <ChooseImage
                        images={images}
                        setImages={setImages}
                        fireDepartmentIdentifier={customMessageEntity.fireDepartmentIdentifier}
                        max={5}
                        elementsAdded={images.length + videos.length}
                        setErrorLabel={setErrorLabel}
                        isMessageEnabled={false}
                        disableHandleClick={disableForm}
                      ></ChooseImage>
                      {images?.map((image, index) => (
                        <MediaThumbnail
                          isDiscardedMedia={isDiscardedMedia}
                          type="image"
                          key={[image.fileName, image.caption, index].join('-')}
                          media={image}
                          index={index}
                          removeMediaEvent={removeAsset}
                          onUpdate={updateAsset}
                          disableHandleClick={disableForm}
                        />
                      ))}
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} className="media-files">
                      <ChooseVideo
                        videos={videos}
                        setVideos={setVideos}
                        fireDepartmentIdentifier={customMessageEntity.fireDepartmentIdentifier}
                        max={5}
                        elementsAdded={images.length + videos.length}
                        setErrorLabel={setErrorLabel}
                        isMessageEnabled={false}
                        isMarketing={isMarketing}
                        disableHandleClick={disableForm}
                      ></ChooseVideo>
                      {videos?.map((video, index) => (
                        <MediaThumbnail
                          isDiscardedMedia={isDiscardedMedia}
                          type="video"
                          key={[video.fileName, video.caption, index].join('-')}
                          media={video}
                          removeMediaEvent={removeAsset}
                          index={index}
                          onUpdate={updateAsset}
                          disableHandleClick={disableForm}
                        />
                      ))}
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} className="media-files">
                      <OnlineVideos
                        videos={onlineVideos}
                        setOnlineVideos={setOnlineVideos}
                        setErrorLabel={setErrorLabel}
                        max={5}
                        disableHandleClick={disableForm}
                      />
                      {onlineVideos?.map((onlineVideo, index) => (
                        <MediaThumbnail
                          isDiscardedMedia={isDiscardedMedia}
                          type="online"
                          key={[onlineVideo.fileName, onlineVideo.caption, index].join('-')}
                          media={onlineVideo}
                          removeMediaEvent={removeAsset}
                          index={index}
                          subType={videoTypes.YoutubeVideos}
                          onUpdate={updateAsset}
                          removeOnlineVideo={removeOnlineVideo}
                          disableHandleClick={disableForm}
                        />
                      ))}
                    </Grid>
                  </Grid>
                  {isMarketing || (
                    <Grid size={12} className="container container-buttons">
                      {!appConfiguration?.previewEnabled ? (
                        <>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="sendPushNotification"
                                color="primary"
                                className="checkbox-notification"
                                checked={customMessageEntity.sendPushNotification}
                                value={customMessageEntity.sendPushNotification}
                                onChange={handleCheckboxChange}
                                disabled={disableForm}
                              />
                            }
                            label="Send notification to users when saved"
                          />
                          <div className="save-button-container">
                            <ButtonSave
                              loading={
                                (!isEmpty(id) && customSectionsSavingInner.includes(id)) ||
                                disabledButton
                              }
                              onClickCallback={saveWithoutPreview}
                              disabled={
                                isReadOnlyMember ||
                                isMarketing ||
                                disabledButton ||
                                customSectionsSaving.includes(customMessageEntity.title)
                              }
                            />
                            <Button
                              style={{ maxWidth: '250px', minWidth: '250px' }}
                              variant="outlined"
                              id="cancelButton3"
                              color="primary"
                              disabled={
                                isReadOnlyMember ||
                                isMarketing ||
                                disabledButton ||
                                customSectionsSaving.includes(customMessageEntity.title)
                              }
                              size="medium"
                              className="cancelButton"
                              onClick={openConfirmationDialog}
                            >
                              Discard
                            </Button>
                            <div>{renderSavedMessage()}</div>
                          </div>
                        </>
                      ) : (
                        <PrepublishButtons
                          isDiscardDialogOpen={isDiscardDialogOpen}
                          isPreviewDialogOpen={isPreviewDialogOpen}
                          isReadOnlyMember={isReadOnlyMember}
                          isShown={appConfiguration.previewEnabled}
                          isSaveDialogOpen={isSaveDialogOpen}
                          openPreviewDialog={openPreviewDialog}
                          openDiscardDialog={openDiscardDialog}
                          closePreviewDialog={closePreviewDialog}
                          closeDiscardDialog={closeDiscardDialog}
                          closeSaveDialog={closeSaveDialog}
                          discardChanges={discardChanges}
                          disabledButton={disabledButton}
                          publishButtonValidations={publishButtonValidations}
                          posting={posting}
                          savePreview={savePreview}
                          savePublish={publishPost}
                          saveDialogCustomContent={saveDialogCustomContent}
                        />
                      )}
                    </Grid>
                  )}
                </form>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </div>
  )
}

export default CustomSection
